import React, { useState, useEffect, useRef } from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [backgroundPosition, setBackgroundPosition] = useState('center center');
  const heroRef = useRef<HTMLElement>(null);

  const slides = [
    {
      id: 1,
      title: 'NAILBOX',
      subtitle: 'Thiết kế độc đáo',
      main: 'Móng Úp',
      tagline: 'Làm đẹp móng tay của bạn với những thiết kế sang trọng và hiện đại',
      buttonText: 'Xem Sản Phẩm',
      buttonLink: '#products',
      backgroundImage: '/hero/z7161918827511_4f815384ec91774f9b6fc3b0829a2bd4.jpg'
    },
    {
      id: 2,
      title: 'MÓNG GIẢ',
      subtitle: 'Thiết kế chuyên nghiệp',
      main: 'Nail Box',
      tagline: 'Bộ sưu tập móng giả đẹp nhất với nhiều mẫu mã đa dạng và phong cách',
      buttonText: 'Mua Ngay',
      buttonLink: '#products',
      backgroundImage: '/hero/z7161918839265_15ea4c3384183fec91fc0b6097ab5cd4.jpg'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sectionTop = rect.top;
        const sectionHeight = rect.height;
        
        // Tính toán vị trí khi section vào viewport
        if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
          // Tính phần trăm scroll trong section
          const scrollProgress = Math.max(0, Math.min(1, (windowHeight - sectionTop) / (windowHeight + sectionHeight)));
          
          // Di chuyển background chậm hơn (parallax effect)
          // Background di chuyển từ center (50%) khi scroll
          const yPos = scrollProgress * 20; // Điều chỉnh 20 để thay đổi tốc độ parallax
          setBackgroundPosition(`center ${50 + yPos}%`); // Đảo ngược: di chuyển xuống thay vì lên
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Gọi ngay để set vị trí ban đầu
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero" ref={heroRef}>
      <div className="hero-slides">
        {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: slide.backgroundImage ? `url(${process.env.PUBLIC_URL}${slide.backgroundImage})` : 'none',
                backgroundSize: '105%',
                backgroundPosition: backgroundPosition,
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'scroll'
              }}
            >
              <div className="hero-overlay"></div>
              <div className="hero-content">
                <h2 className="hero-title">{slide.title}</h2>
                {slide.subtitle && <p className="hero-subtitle">{slide.subtitle}</p>}
                {slide.main && <h1 className="hero-main">{slide.main}</h1>}
                <p className="hero-tagline">{slide.tagline}</p>
                <a href={slide.buttonLink} className={index === 0 ? 'btn-primary' : 'btn-secondary'}>
                  {slide.buttonText}
                </a>
              </div>
            </div>
        ))}
      </div>
      <div className="hero-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;

